const isOverMininumCount = (count, minCount) => {
	return count >= minCount;
};

const getPosProviderDetail = (selected, posList) => {
	return posList?.find(({ value }) => value === selected.value);
};

export { isOverMininumCount, getPosProviderDetail };
